import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { getImageUrl } from '../services/api';

interface PopupData {
  id: number;
  title?: string;
  description?: string;
  image_url: string;
  url?: string;
  is_active: boolean;
}

interface PopupProps {
  popup: PopupData;
  open: boolean;
  onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ popup, open, onClose }) => {
  const handleClose = () => {
    onClose();
  };

  const handleImageClick = () => {
    if (popup.url) {
      window.open(popup.url, '_blank');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          overflow: 'hidden',
          position: 'relative',
        },
      }}
    >
      {/* Close button */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        {/* Image */}
        <Box
          component="img"
          src={getImageUrl(popup.image_url)}
          alt={popup.title || 'Popup'}
          sx={{
            width: '100%',
            height: 'auto',
            cursor: popup.url ? 'pointer' : 'default',
            display: 'block',
          }}
          onClick={handleImageClick}
        />

        {/* Content */}
        {(popup.title || popup.description) && (
          <Box sx={{ p: 3 }}>
            {popup.title && (
              <Typography
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 'bold',
                  mb: popup.description ? 2 : 0,
                  color: '#009F9A',
                }}
              >
                {popup.title}
              </Typography>
            )}

            {popup.description && (
              <Typography
                variant="body1"
                sx={{
                  color: '#374151',
                  lineHeight: 1.6,
                }}
              >
                {popup.description}
              </Typography>
            )}

            {popup.url && (
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  backgroundColor: '#009F9A',
                  '&:hover': {
                    backgroundColor: '#008B85',
                  },
                }}
                onClick={() => window.open(popup.url, '_blank')}
              >
                Learn More
              </Button>
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default Popup; 